import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './AddList.module.scss';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';


import * as actions from 'store/actions/index';
import AddList from 'Flow2/components/AddList/AddList';


class TagCatalogAddList extends React.Component {
    
    componentDidMount() {
        //this.props.loadTags();
    }
	
	addMemberHandler = (input) => {
        if (input) {
            this.props.addMemberToProject(this.props.project, input);
        }
    }

    removeMemberHandler = (input) => {
        if (input) {
            this.props.delMemberFromProject(this.props.project, input);
        }
    }
    
    render = () => {
		const data = this.props.data;

        const add = (input) => {
            if (input && data.indexOf(input) === -1) {
                data.unshift(input);
                this.props.add(data.join(this.props.separator));
				this.addMemberHandler(input);
            }
        }
        
        const remove = (index) => {
            let elm = data.splice(index, 1);
            this.props.remove(data.join(this.props.separator));
			if(elm.length) {
				this.removeMemberHandler(parseInt(elm[0]));
			}
        }
        
        return (
            <AddList
                key={this.props.key}
                data={data}
                list={this.props.users}
                valueField={"id"}
                labelField={"email"}
                showAll={this.props.showAll}
                add={this.props.add ? add : null}
                remove={this.props.remove ? remove : null}
            />
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
		users: state.user.users,
        separator: ownProps.separator || ';'
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addMemberToProject: (id, member) => dispatch(actions.addMemberToProject(id, member)),
        delMemberFromProject: (projectId, memberId) => dispatch(actions.delMemberFromProject(projectId, memberId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagCatalogAddList);
